<template>
  <v-toolbar flat color="transparent" class="toolbar">
    <v-row dense align="center">
      <v-col v-if="!$props.fixed" class="flex-grow-0 flex-shrink-1">
        <v-menu bottom right offset-y
          v-model="form.lib"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <v-icon small color="secondary">{{ printSelectedBoxIcon }}</v-icon>&nbsp;{{ printSelectedBoxLabel }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="$props.lib.media && store.box.type !== 'media'"
              @click.stop="changeLibrary({ type: 'media', rid: $props.lib.media })">
              <v-list-item-icon><v-icon small>fal fa-books</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>メディア</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item v-if="store.box.type !== 'shared'"
              @click.stop="changeLibrary({ type: 'shared' })">
              <v-list-item-icon><v-icon small>fal fa-user-friends</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>共有アイテム</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item v-if="$props.lib.trash && store.box.type !== 'trash'"
              @click.stop="changeLibrary({ type: 'trash', rid: $props.lib.trash })">
              <v-list-item-icon><v-icon small>fal fa-trash-alt</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>ごみ箱</v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-group>
              <v-list-item slot="activator">
                <v-list-item-icon><v-icon small>fal fa-file-contract</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>手配</v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-for="item in $props.lib.arranges"
                :key="item.id"
                @click.stop="changeLibrary({ type: 'arrange', rid: item.mid })">
                <v-list-item-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>{{ item.title }}</v-list-item-title></v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>
      </v-col>
      <v-col class="text-center flex-grow-0 flex-shrink-1">
        <v-icon small>fal fa-chevron-right</v-icon>
      </v-col>
      <v-col
        :class="['body-1 current breadcrumbs-wrap flex-grow-1 flex-shrink-0', { dragovered: config.status.breadcrumbs }]"
        @dragover="dragover(null)"
        @dragleave="dragleave(null)">
        <div><v-icon small color="secondary">fa-folder-open</v-icon>&nbsp;{{ printCurrentDir }}</div>
        <v-list class="breadcrumbs">
          <v-list-item v-for="item in getTailItems" :key="item.id"
            :class="{
              'grey': item.dragovering,
              'lighten-2': item.dragovering
            }"
            @drop="drop(item)"
            @dragover="dragover(item)"
            @dragleave="dragleave(item)"
            @click.stop="backward(item)">
            <v-list-item-icon><v-icon small color="secondary">fa-folder</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name ? item.name : '全てのファイル' }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-btn outlined v-if="$vuetify.breakpoint.smAndUp && !isCoreLoading && isAuthed && isAddable" @click.stop="mkdir"><v-icon small>fal fa-plus</v-icon>&nbsp;新規フォルダ</v-btn>
    <v-btn v-if="$vuetify.breakpoint.smAndUp && !isCoreLoading && isAuthed && isAddable"
      depressed
      class="ml-4"
      color="secondary"
      @click.stop="$refs.fileInputer.click()">
      <v-icon small>fal fa-upload</v-icon>&nbsp;アップロード
    </v-btn>
    <input type="file" multiple="multiple" ref="fileInputer"
      style="display:none;"
      :disabled="isCoreLoading || isUploading"
      @change="upload($event.target.files)"
    />
  </v-toolbar>
</template>

<script>
const DEF = {
  STATUS: {
    LOADING: false,
    MKDIR: false,
    BREADCRUMBS: false,
    IMPORT: false
  },
  STORE: {
    BOX: {
      TYPE: 'media',
      LABEL: 'メディア'
    }
  }
}
export default {
  name: 'clientFilerToolbar',
  components: {
  },
  props: [
    'lib',
    'status',
    'fixed'
  ],
  data () {
    return {
      config: {
        status: {
          mkdir: DEF.STATUS.MKDIR,
          upload: DEF.STATUS.UPLOAD,
          breadcrumbs: DEF.STATUS.BREADCRUMBS
        }
      },
      form: {
        lib: false
      },
      store: {
        authed: false,
        box: {
          type: DEF.STORE.BOX.TYPE,
          label: DEF.STORE.BOX.LABEL
        },
        items: []
      }
    }
  },
  methods: {
    init: function (id) {
      if (id) {
        this.$set(this.store, 'items', [{
          id: id,
          type: 'folder'
        }])
      } else {
        this.$set(this.store, 'items', [])
      }
    },
    upload: function (files) {
      if (files && files.length) {
        this.$emit('emit', {
          action: 'upload',
          data: files
        })
      }
    },
    mkdir: function () {
      if (this.store.items && this.store.items.length) {
        this.$emit('emit', {
          action: 'mkdir',
          data: this.store.items[0]
        })
      }
    },
    forward: function (item) {
      if (item && item.id) {
        if (this.store.items.length && this.store.items[0].type === 'shared') {
          item.tags.shared = true
        }
        this.store.items.unshift(item)
        if (item.tags && item.tags.authed) {
          this.$set(this.store, 'authed', item.tags.authed)
        }
      }
    },
    backward: function (item) {
      if (item && item.id) {
        let idx = this.store.items.findIndex(it => {
          return it.id === item.id
        })
        if (idx >= 0) {
          this.store.items.splice(0, idx + 1)
          const auths = this.store.items.filter(it => { return !!it.tags.authed })
          if (auths.length) {
            this.$set(this.store, 'authed', auths[auths.length - 1])
          } else {
            this.$set(this.store, 'authed', false)
          }
        }
        this.$emit('emit', {
          action: 'get',
          data: item
        })
      }
    },
    changeLibrary: function (req) {
      const { type, rid } = req
      let permits = {}
      if (type) {
        this.$set(this.form, 'lib', false)
        this.$set(this.store, 'items', [])
        if (type === 'media') {
          this.$set(this.store, 'box', {
            type: 'media',
            label: 'メディア'
          })
          permits = {
            add: true,
            modify: true,
            trash: true,
            share: true
          }
        } else if (type === 'shared') {
          this.$set(this.store, 'box', {
            type: 'shared',
            label: '共有アイテム'
          })
          permits = {
            add: true,
            modify: true,
            trash: true,
            share: false
          }
        } else if (type === 'trash') {
          this.$set(this.store, 'box', {
            type: 'trash',
            label: 'ごみ箱'
          })
          permits = {
            add: false,
            modify: false,
            trash: false,
            share: false
          }
        } else if (type === 'arrange') {
          let idx = this.$props.lib.arranges.findIndex(it => {
            return it.mid === rid
          })
          if (idx >= 0) {
            this.$set(this.store, 'box', {
              type: 'arrange',
              label: this.$props.lib.arranges[idx].title
            })
          }
          permits = {
            add: false,
            modify: false,
            trash: true,
            share: false
          }
        }
        this.$emit('emit', {
          action: 'init',
          data: { type, rid, permits }
        })
      }
    },
    dragover: function (item) {
      if (item && item.id) {
        this.$set(item, 'dragovering', true)
      } else {
        this.$set(this.config.status, 'breadcrumbs', true)
      }
    },
    dragleave: function (item) {
      if (item && item.id) {
        this.$set(item, 'dragovering', false)
      } else {
        this.$_.debounce(() => {
          if (this.store.items.filter(it => {
            return it.dragovering
          }).length === 0) {
            this.$set(this.config.status, 'breadcrumbs', false)
          }
        }, 100)()
      }
    },
    drop: function (item) {
      this.$set(this.config.status, 'breadcrumbs', false)
      if (item && item.id) {
        this.$set(item, 'dragovering', false)
        this.$emit('emit', {
          action: 'move',
          data: item
        })
      }
    },
    getCurrentDir: function () {
      return (this.store.items.length) ? this.store.items[0] : null
    }
  },
  computed: {
    isLocked () {
      return !!(
        this.store.items.length &&
        this.store.items[0].tags &&
        this.store.items[0].tags.authed
      )
    },
    isAuthed () {
      return !this.store.authed || (this.store.authed === this.$store.getters['author/get']('userid'))
    },
    isTrashed () {
      return this.store.box.type === 'trash'
    },
    isShared () {
      return !!(
        this.store.items.length &&
        this.store.items[0].type === 'shared'
      )
    },
    isRootShared () {
      return !!(this.store.items.length && this.store.items[this.store.items.length - 1].type === 'shared')
    },
    hasSharedDirectory () {
      return this.store.items.filter(it => { return it.tags && it.tags.shared }).length > 0
    },
    isMkDiring () {
      return this.config.status.mkdir
    },
    isUploading () {
      return this.$props.status && this.$props.status.uploading
    },
    isAddable () {
      return (
        this.$props.status &&
        this.$props.status.permits &&
        this.$props.status.permits.add
      )
    },
    isLibrarySwappable () {
      return (
        this.$props.lib &&
        this.$props.lib.media
      )
    },
    isCoreLoading () {
      return this.$props.status && this.$props.status.loading
    },
    isEmpty () {
      return !(
        this.store.items.length
      )
    },
    isSingle () {
      return !!(
        this.store.items.length &&
        this.store.items.length === 1
      )
    },
    printCurrentDir () {
      return (
        this.store.items.length &&
        this.store.items[0].name
      ) ? this.store.items[0].name : '全てのファイル'
    },
    printSelectedBoxLabel () {
      return this.store.box.label
    },
    printSelectedBoxIcon () {
      if (this.store.box.type === 'media') {
        return 'fa-books'
      } else if (this.store.box.type === 'trash') {
        return 'fa-trash'
      } else if (this.store.box.type === 'arrange') {
        return 'fa-file-contract'
      } else if (this.store.box.type === 'shared') {
        return 'fa-user-friends'
      } else {
        return ''
      }
    },
    getItems () {
      return this.store.items
    },
    getTailItems () {
      return this.store.items.length ? this.store.items.filter(it => {
        return it.id !== this.store.items[0].id
      }) : []
    }
  }
}
</script>

<style lang="scss">
.filer {
  .toolbar {
    z-index: 1;
    .breadcrumbs-wrap {
      position: relative;
      cursor: default;
      &:hover,
      &.dragovered {
        .breadcrumbs {
          display: flex;
        }
      }
      .breadcrumbs {
        display: none;
        position: absolute;
        top: calc(100% - .5em);
        left: 0;
        z-index: 8;
        box-shadow: $float;
        flex-direction: column;
        &:hover {
          display: flex;
        }
      }
    }
  }
}
</style>
